import axios from "axios";

/**
 * Production: uses REACT_APP_API_BASE from .env.production
 * Example: https://myanotherdomain.co.in/expert
 *
 * Dev fallback: keeps your old working URL
 */
const API_BASE =
  (process.env.REACT_APP_API_BASE || "").replace(/\/+$/, "") ||
  "https://idairy.co.in/expert";

export const BASE_URL = `${API_BASE}/php/cust/`;

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  headers: {
    Accept: "application/json",
  },
});

/**
 * Android server returns "String" sometimes with garbage/BOM.
 * This copies your extractJsonObject() logic.
 */
export function extractJsonObject(str) {
  if (!str) return "{}";
  let s = String(str).replace("\uFEFF", "").trim();
  const start = s.indexOf("{");
  const end = s.lastIndexOf("}");
  if (start >= 0 && end >= start) s = s.substring(start, end + 1);
  return s;
}
